export function PRODUTOS(state) {
  return state.produtos;
}
